import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";

export const PescaScreen: React.FC = () => {
	return (
		<>
			<Row
				flexible
				mainAxisAlignment="center"
				crossAxisAlignment="center"
				className="relative py-14 max-md:px-5 md:py-36 bg-cover bg-[url('https://peru.oceana.org/wp-content/uploads/sites/22/bycatch_pesca_incidental_tom_campbell.jpg')] bg-center"
				responsiveCol
			>
				<div className="absolute bg-black/40 top-0 left-0 w-full h-full" />
				<Column
					className="w-full z-[1]"
					data-sal="zoom-out"
					data-sal-duration="1000"
				>
					<TextComponent
						variant="extraBig"
						className="font-title max-md:text-4xl text-center !leading-none text-white"
					>
						Pesca <br /> indiscriminada
					</TextComponent>
				</Column>
			</Row>
			<Row
				className="gap-5 md:gap-10 self-center max-md:mt-10 md:py-10 max-md:px-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				responsiveCol
			>
				<img
					className="md:w-2/5 h-60 object-cover rounded-lg max-md:order-last"
					src="https://diariocorreo.pe/resizer/UHiOrLeqZSUgMKVCeeBs5YpYNtE=/1200x682/smart/filters:format(jpeg):quality(75)/arc-anglerfish-arc2-prod-elcomercio.s3.amazonaws.com/public/E5T6P2V4XJFBDLKDIVIIYC6EPE.jpg"
					alt="varios barcos con aves volando en el mar"
					data-sal="slide-right"
					data-sal-duration="1000"
				/>
				<Column
					className="md:w-3/5 rounded-lg md:gap-4 gap-2"
					data-sal="slide-left"
					data-sal-duration="1000"
					mainAxisAlignment="center"
				>
					<TextComponent
						variant="h1"
						className="font-title"
					>
						Colapso de Especies Comerciales
					</TextComponent>
					<TextComponent variant="h5">
						e informó una <span className="font-semibold text-red-600">significativa disminución</span> en la cantidad de especies que se destinan al proceso de{" "}
						<span className="font-bold text-yellow-600">congelación</span>, con una reducción del <span className="font-bold text-red-600">92.8%</span>. Además, resulta notable la{" "}
						<span className="font-semibold text-red-600">completa ausencia</span> de la pesca destinada a la producción en la modalidad de{" "}
						<span className="font-bold text-yellow-600">secado</span>, con un descenso total del <span className="font-bold text-red-600">100%</span>. Estas variaciones tuvieron un impacto
						considerable, <span className="font-semibold">moderado el desempeño general del sector pesquero</span>.
					</TextComponent>
				</Column>
			</Row>
			<Column className="grid grid-cols-1 md:grid-cols-2 sm:w-[40rem] md:w-[50rem] xl:w-[60rem] gap-5 self-center py-10 max-md:px-5">
				<img
					className="rounded-lg"
					src="https://prensaregional.pe/wp-content/uploads/2023/09/Graficos-Caida-del-sector-pesca-en-el-sur-18092023-1.jpg"
					alt="estadisticas del sector de pesca"
					data-sal="slide-right"
					data-sal-duration="1000"
				/>
				<img
					className="rounded-lg"
					src="https://prensaregional.pe/wp-content/uploads/2023/09/Graficos-Caida-del-sector-pesca-en-el-sur-18092023-2-scaled.jpg"
					alt="informacion de la pesca en el sur peruano"
					data-sal="slide-left"
					data-sal-duration="1000"
				/>
				<img
					className="rounded-lg"
					src="https://scontent.ftcq2-1.fna.fbcdn.net/v/t39.30808-6/481125234_962640019340103_8597402535783280857_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=127cfc&_nc_eui2=AeFH4q8P4P6RgkeejcKdyyl50wxKZB-ZD4fTDEpkH5kPh21ePJNEnHq5-NCMdISqw3_uVIZco9MiAnqnAdPReqA4&_nc_ohc=JPup6cRBDpAQ7kNvwGE5Hlu&_nc_oc=Adn4DSUGQF1RTr68n_6rX0MEUYhp-7b-narouifCVETeZZdjR2JzcQKifnz5AUVG2C0&_nc_zt=23&_nc_ht=scontent.ftcq2-1.fna&_nc_gid=f8ukCbHhATQigQ57N85njQ&oh=00_AfISZafZGrJsOusDBrlpvXGAD_UMrfOXYXvELlkq-56iLg&oe=682D6758"
					alt="informacion de lo que es un pez juvenil"
					data-sal="slide-right"
					data-sal-duration="1000"
				/>
				<img
					className="rounded-lg"
					src="https://scontent.ftcq2-1.fna.fbcdn.net/v/t39.30808-6/301997059_3349116051978396_7922409964054448030_n.png?_nc_cat=107&ccb=1-7&_nc_sid=127cfc&_nc_eui2=AeEHzFku-CFYPPZbjJRRPg-AZfv8OEDzcxhl-_w4QPNzGBzfwapMYESh97oeE57KGr9hcWC3iv9JPVMj4Nrk3k0-&_nc_ohc=RSUBkwyF_woQ7kNvwEIFCN_&_nc_oc=Admac53idBKI41TbEZQb-6ZQiKNtjrfo0AkZ8F8hCXrWbiidJxwAOc6YIWw-UQv-xuE&_nc_zt=23&_nc_ht=scontent.ftcq2-1.fna&_nc_gid=NnK5nrejV0denLo5tvDFow&oh=00_AfLpBHSr2PnUYNHT8w7mZsWTK969T0asV-JBBAt6oGPnAg&oe=682D71D1"
					alt="monografia acerca de las doscientas millas de abundancia"
					data-sal="slide-left"
					data-sal-duration="1000"
				/>
			</Column>
		</>
	);
};
